import { render, staticRenderFns } from "./ModalAtendimentos.vue?vue&type=template&id=695103e9&scoped=true"
import script from "./ModalAtendimentos.vue?vue&type=script&lang=js"
export * from "./ModalAtendimentos.vue?vue&type=script&lang=js"
import style0 from "./ModalAtendimentos.vue?vue&type=style&index=0&id=695103e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695103e9",
  null
  
)

export default component.exports